import React from 'react';
import { INFO_PAGES, INFO_PAGE_ORDER, InfoPanel } from './infoPages';

// The menu button in the top-right corner of the special order page: three lines
// that open the information pages.
//
// Self-contained on purpose — it holds its own state, so the order page only has
// to render <SpecialOrderMenu /> and nothing else changes there. The pages and
// the panel they open in live in infoPages.js, shared with the page footer.

const SpecialOrderMenu = () => {
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = React.useState(null);

    // Escape closes the dropdown. The panel closes itself the same way.
    React.useEffect(() => {
        if (!open) return undefined;

        const handleKeyDown = (e) => {
            if (e.key !== 'Escape') return;
            e.preventDefault();
            setOpen(false);
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open]);

    const openPage = (key) => {
        setOpen(false);
        setPage(key);
    };

    return (
        <>
            <button
                type="button"
                className="so-menu__trigger"
                onClick={() => setOpen(true)}
                aria-label="Menu"
                aria-expanded={open}
            >
                <i className="pi pi-bars" />
            </button>

            {open && (
                // The backdrop dims and closes on an outside tap; the anchor keeps
                // the panel under the button — mirroring the phone's centred 480px
                // column, and widening with the page on a computer.
                <div className="so-menu__backdrop" onClick={() => setOpen(false)}>
                    <div className="so-menu__anchor">
                        <div className="so-menu__panel" role="menu" onClick={(e) => e.stopPropagation()}>
                            {INFO_PAGE_ORDER.map((key) => (
                                <button
                                    type="button"
                                    role="menuitem"
                                    key={key}
                                    className="so-menu__item"
                                    onClick={() => openPage(key)}
                                >
                                    <i className={INFO_PAGES[key].icon} />
                                    <span>{INFO_PAGES[key].title}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <InfoPanel pageKey={page} onClose={() => setPage(null)} />
        </>
    );
};

export default SpecialOrderMenu;
